export default "__VITE_ASSET__h1$mL910__"